import axios from '@/libs/api.request'

/**
 * 删除OCR暂存记录
 */
export const delOcrLog = (data_id) => {
    let data = {
        'id': data_id
    }
    return axios.request({
        url: '/api/admin/ocrlog/del',
        data,
        method: 'post'
    })
}